import { css } from '@emotion/css'

import { spacing } from '../../../../styles'

const styles = {
  title: css({
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre',
  }),
  icon: css({
    marginRight: spacing.small,
  }),
}

export default styles
